import {availableFonts, colorRegex} from '../../../constants';
import yup from '../../../yup';

export const buttonsSchema = yup.object().shape({
    backgroundColor: yup.string().matches(colorRegex),
    backgroundHoverColor: yup.string().matches(colorRegex),
    textColor: yup.string().matches(colorRegex),
    textHoverColor: yup.string().matches(colorRegex),
    font: yup.string().oneOf(availableFonts),
    fontSize: yup.number().min(0),
    radius: yup.number().min(0),
    paddingVertical: yup.number().min(0),
    paddingHorizontal: yup.number().min(0),
    borderColor: yup.string().matches(colorRegex),
    borderHoverColor: yup.string().matches(colorRegex),
    borderWidth: yup.number().min(0),
});
